const PROGRESS_LABELS = {
  0: "Not Started",
  1: "In Progress",
  2: "Completed",
  NotStarted: "Not Started",
  InProgress: "In Progress",
  Complete: "Completed",
  Completed: "Completed",
};

/**
 * Returns a function that converts a progress status value (number or string)
 * to a human-readable label.
 *
 * Usage:
 *   const getProgressLabel = useProgressLabel();
 *   getProgressLabel(user.progressStatus) // → "In Progress"
 */
export default function useProgressLabel() {
  return (status) => PROGRESS_LABELS[status] ?? "Unknown";
}
